import { render, staticRenderFns } from "./largeScreenDisplaySettings.vue?vue&type=template&id=03e644fc&scoped=true"
import script from "./largeScreenDisplaySettings.vue?vue&type=script&lang=js"
export * from "./largeScreenDisplaySettings.vue?vue&type=script&lang=js"
import style0 from "./largeScreenDisplaySettings.vue?vue&type=style&index=0&id=03e644fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e644fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e644fc')) {
      api.createRecord('03e644fc', component.options)
    } else {
      api.reload('03e644fc', component.options)
    }
    module.hot.accept("./largeScreenDisplaySettings.vue?vue&type=template&id=03e644fc&scoped=true", function () {
      api.rerender('03e644fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/otherMarket/views/largeScreenDisplaySettings.vue"
export default component.exports